import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export async function startCheckout(lookupKey, quantity = 1, size = null) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    quantity,
    origin_url: window.location.origin,
    ...(size ? { size } : {}),
  });
  window.location.href = data.checkout_url;
}
